module.exports = __webpack_public_path__ + "web/img/img5.37dd8c40.png";